module.exports = __webpack_public_path__ + "static/media/noOrgLogo.4d035c8a.png";